import { toLocalGrid } from './coordinates';

// The variogram backend measures distance as plain Euclidean distance between the `lon`/`lat`
// values it is sent. Sending degrees gave lags of about 0.01 with no unit (V.30), so the
// points go in as metres east/north of the layer's centroid and the lags come back in metres.

const M_PER_DEG_LAT = 111320;

/** Mean metres per degree at a latitude (lon degrees shrink with cos(lat)); used to turn a
 *  range in metres back into the degrees the kriging endpoint works in. */
export function metresPerDegree(latDeg) {
  const c = Math.cos(((Number.isFinite(latDeg) ? latDeg : 0) * Math.PI) / 180);
  return (M_PER_DEG_LAT * (1 + Math.max(0.01, c))) / 2;
}

/**
 * Points ({lon, lat, value, ...}) -> the same points with lon/lat replaced by metres east/north
 * of their centroid, plus the centroid and the metres-per-degree factor for the way back.
 */
export function toMetricPoints(points) {
  if (!points || !points.length) return { points: [], origin: null, mPerDeg: M_PER_DEG_LAT };
  const lon0 = points.reduce((s, p) => s + p.lon, 0) / points.length;
  const lat0 = points.reduce((s, p) => s + p.lat, 0) / points.length;
  const origin = { lon: lon0, lat: lat0 };
  const out = points.map((p) => {
    const { x, y } = toLocalGrid(p.lon, p.lat, origin);
    return { ...p, lon: x, lat: y };
  });
  return { points: out, origin, mPerDeg: metresPerDegree(lat0) };
}

/** Axis / slider label for a distance in metres. */
export function formatLag(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '';
  return Math.abs(n) >= 1000 ? `${(n / 1000).toFixed(1)} km` : `${Math.round(n)} m`;
}
